import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import CompanyStory from './components/CompanyStory';
import Timeline from './components/Timeline';
import CompanyValues from './components/CompanyValues';
import EquipmentShowcase from './components/EquipmentShowcase';
import RealizationsGallery from './components/RealizationsGallery';
import TeamSection from './components/TeamSection';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <>
      <Navigation />
      <main>
        <AboutHero />
        <CompanyStory />
        <Timeline />
        <CompanyValues />
        <EquipmentShowcase />
        <RealizationsGallery />
        <TeamSection />
        <AboutCTA />
      </main>
      <Footer />
    </>
  );
}
